<template>
  <div>
    <DataTable :options="options"
               :params="{
                  operation_type: [
                    'write_off',
                    'return',
                    'movement_from',
                    'addition',
                    'inventarization',
                    'adjustment',
                    'consumption_manual',
                    'sale'
                  ]
               }"
               module="warehouse"/>
  </div>
</template>

<script setup>
import DataTable from "../../parts/general/DataTable"
import options from "../../../data/warehouse/warehouseoperation"
import { useHead } from "@unhead/vue"
import {useStore} from "vuex"
import {getCurrentInstance, onBeforeMount, onMounted, ref} from "vue"

const store = useStore()
let i18n = null
const title = ref('')

useHead({
  title: () => title.value,
})

onBeforeMount(() => {
  i18n = (getCurrentInstance())?.ctx?.$i18n
  title.value = i18n.t('documents')
})

onMounted(() => {
  store.commit('setEloquentOptions', options)
})
</script>
